// extracted by mini-css-extract-plugin
module.exports = {"headerWidgetInner":"_b8f9ad9","scrolled":"_2e49f11","hideOnScroll":"_0468293"};